import React, { Component, Fragment } from 'react';
import { PermissionsAndroid, ScrollView, View } from 'react-native';
import { checkNotifications } from 'react-native-permissions';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  get as _get,
  isArray as _isArray,
  forEach as _forEach,
  cloneDeep as _cloneDeep,
  isFunction as _isFunction,
} from 'lodash';
import PropTypes from 'prop-types';

import { VFText, VFButton, TimelineEvents, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PermissionsManager from '@vfgroup-oneplatform/foundation/PermissionsManager';
import {
  IOSPermissionTypes,
  localPermissions,
  permissions,
} from '@vfgroup-oneplatform/foundation/PermissionsManager/permissionTypes';

import FrameworkTestKeys from '../../FrameworkTestKeys';
import PermissionsItem from '../PermissionsItem/PermissionsItem';

import styles from './PermissionsView.Styles';

class PermissionsView extends Component {
  constructor(props) {
    super(props);

    this.permissionsTogglesAppearance = {};

    const initialPermissionsStatuses = {};
    if (_get(props, 'permissionsProp')) {
      this.getPermissions(props.permissionsProp, initialPermissionsStatuses, true);
    }

    this.state = {
      permissionsStatus: initialPermissionsStatuses,
    };
  }

  componentDidMount() {
    this.getPermissionsStatus();
    TimelineEvents.subscribe(this.setToBiProps);
  }

  onPermissionItemAcceptanceChange = (accepted, permission) => {
    const permissionsStatus = _cloneDeep(this.state.permissionsStatus);
    permissionsStatus[permission.permissionsKey] = accepted;

    if (!accepted) {
      this.getPermissions(
        permission.subPermissions,
        permissionsStatus,
        false,
        permission.permissionsKey,
      );
    } else {
      this.getPermissions(
        permission.subPermissions,
        permissionsStatus,
        true,
        permission.permissionsKey,
      );
    }

    this.setState({ permissionsStatus });
    if (this.props.withTracking && this.props.onPermissionStatusChange) {
      this.props.onPermissionStatusChange(permission, accepted);
    }
  };

  getPermissionStatusData = () => {
    const { customPermissionsHandling } = this.props;
    const permissionsStatusesPromises = [];
    const permissionsKeys = [];

    Object.keys(this.state.permissionsStatus).forEach(permissionKey => {
      if (this.permissionsTogglesAppearance[permissionKey]) {
        switch (permissionKey) {
          case localPermissions.NETWORK:
          case localPermissions.PERSONALIZED_SERVICES:
          case localPermissions.BIOMETRIC:
            if (customPermissionsHandling.getNetperformPermissionsStatus) {
              permissionsStatusesPromises.push(
                customPermissionsHandling.getNetperformPermissionsStatus(permissionKey),
              );
              permissionsKeys.push(permissionKey);
            }
            break;

          case IOSPermissionTypes.PUSH_NOTIFICATIONS:
            permissionsStatusesPromises.push(checkNotifications());
            permissionsKeys.push(permissionKey);
            break;

          default:
            permissionsStatusesPromises.push(
              PermissionsManager.getPermissionStatus(permissions[permissionKey]),
            );
            permissionsKeys.push(permissionKey);
            break;
        }
      }
    });

    return { permissionsStatusesPromises, permissionsKeys };
  };

  getPermissionStateResult = res => {
    if (res.status) {
      return res.status == PermissionsAndroid.RESULTS.GRANTED;
    } else if (typeof res === 'string') {
      return res == PermissionsAndroid.RESULTS.GRANTED;
    } else {
      return res;
    }
  };

  getPermissionsStatus = async () => {
    const { permissionsStatusesPromises, permissionsKeys } = this.getPermissionStatusData();
    const updatedPermissionsStatuses = { ...this.state.permissionsStatus };

    const promises = permissionsStatusesPromises.map(p =>
      p
        .then(value => ({
          status: 'fulfilled',
          value,
        }))
        .catch(reason => ({
          status: 'rejected',
          reason,
        })),
    );

    await Promise.all(promises).then(results => {
      results.forEach((res, index) => {
        const permissionKey = permissionsKeys[index];
        updatedPermissionsStatuses[permissionKey] = res.value
          ? this.getPermissionStateResult(res.value)
          : false;
      });
    });

    this.setState({ permissionsStatus: updatedPermissionsStatuses });
  };

  getPermissions = (permissionsArr, savedPermissions, value, parent = null) => {
    if (_isArray(permissionsArr) && permissionsArr.length > 0) {
      _forEach(permissionsArr, permission => {
        savedPermissions[permission.permissionsKey] = value;
        this.permissionsTogglesAppearance[permission.permissionsKey] = permission.withToggleAsText;
        this.permissionsParents[permission.permissionsKey] = parent;
        this.getPermissions(
          permission.subPermissions,
          savedPermissions,
          value,
          permission.permissionsKey,
        );
      });
    }
  };

  setToBiProps = value => {
    const { isActive, initToBi, setToBiSize, withToBi, setToBiX, setToBiY } = this.props;

    if (isActive && withToBi) {
      if (_isFunction(initToBi)) {
        initToBi(50, value, 140);
      }

      if (_isFunction(setToBiSize)) {
        setToBiSize(140);
      }
      if (_isFunction(setToBiX)) {
        setToBiX(50);
      }
      if (_isFunction(setToBiY)) {
        setToBiY(value + 50);
      }
    }
  };

  requestPermissions = async (customPermissionsHandling, config) => {
    const { onNextStep } = this.props;
    const permissionsManager = new PermissionsManager();
    const result = await permissionsManager.requestPermissions(
      config,
      this.state.permissionsStatus,
      customPermissionsHandling,
    );
    this.setState(
      {
        permissionsStatus: result,
      },
      () => onNextStep(),
    );
  };

  permissionsParents = {};

  isParentClosed = key => {
    if (this.permissionsParents[key]) {
      if (this.state.permissionsStatus[this.permissionsParents[key]]) {
        this.isParentClosed(this.permissionsParents[key]);
      } else {
        return true;
      }
    } else {
      return !this.state.permissionsStatus[key];
    }
  };

  renderPermissionItems = (item, index, itemList) => {
    const isClosed =
      this.permissionsParents[item.permissionsKey] && this.isParentClosed(item.permissionsKey);
    const hasSubPermissions = _isArray(item.subPermissions) && item.subPermissions.length > 0;

    const isLastPermission =
      !hasSubPermissions && itemList[itemList.length - 1]?.permissionsKey === item.permissionsKey;

    const { permissionsStatus } = this.state;
    return (
      <Fragment key={index}>
        <PermissionsItem
          closed={isClosed}
          isLastPermission={isLastPermission}
          images={this.props.stepsImages}
          icon={item.icon}
          index={index}
          title={item.title}
          withToggleAsText={item.withToggleAsText}
          description={item.description}
          accessibilityLabelView={item.id}
          onAcceptanceChange={accepted => this.onPermissionItemAcceptanceChange(accepted, item)}
          initialValue={permissionsStatus[item.permissionsKey] || false}
        />

        {hasSubPermissions &&
          item.subPermissions.map((_item, _index) => {
            return this.renderPermissionItems(_item, _index, item.subPermissions);
          })}
      </Fragment>
    );
  };

  render() {
    const {
      customPermissionsHandling,
      config,
      image,
      stepsImages,
      withToBi,
      renderPermissonsFooter,
    } = this.props;
    const stepImage = stepsImages[image] || '';

    return (
      <View style={styles.container} testID={FrameworkTestKeys.customPermissionsContainer}>
        <View style={styles.descriptionContainer} testID={FrameworkTestKeys.customPermissionsView}>
          <VFText
            style={styles.text}
            i18nKey={this.props.description}
            testKey={FrameworkTestKeys.OBPermissionsStepDesc}
          />
          {!withToBi && <Icon type={'image'} name={stepImage} style={styles.stepImage} />}
        </View>

        <ScrollView testID={FrameworkTestKeys.customPermissionsSV}>
          {this.props.permissionsProp.map((item, index) => {
            return this.renderPermissionItems(item, index, this.props.permissionsProp);
          })}
        </ScrollView>
        {_isFunction(renderPermissonsFooter) && renderPermissonsFooter()}
        <VFButton
          title={this.props.actionTitle1}
          onPress={() => {
            this.requestPermissions(customPermissionsHandling, config);
          }}
          style={[styles.button, this.props.actionStyle]}
          testKey={FrameworkTestKeys.OBHappyButton}
        />
      </View>
    );
  }
}
PermissionsView.defaultProps = {
  theme: LightThemeColors,
  withTracking: false,
};
PermissionsView.propTypes = {
  onNextStep: PropTypes.func,
  permissionsProp: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      icon: PropTypes.string,
      permissionsKey: PropTypes.string,
      subPermissions: PropTypes.array,
    }),
  ),
  actionTitle1: PropTypes.string,
  description: PropTypes.string,
  isActive: PropTypes.bool,
  initToBi: PropTypes.func,
  setToBiSize: PropTypes.func,
  withToBi: PropTypes.bool,
  setToBiX: PropTypes.func,
  setToBiY: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  stepsImages: PropTypes.object,
  config: PropTypes.object,
  image: PropTypes.string,
  customPermissionsHandling: PropTypes.object,
  withTracking: PropTypes.bool,
  onPermissionStatusChange: PropTypes.func,
  renderPermissonsFooter: PropTypes.func,
  actionStyle: ViewPropTypes.style,
};

export default withTheme(PermissionsView);
